import { ErrorCodes } from './ErrorCodes';

export class PlayerError extends Error {
  name: string;
  code: ErrorCodes;

  constructor(code: ErrorCodes = ErrorCodes.DEFAULT, message?: string) {
    super();
    this.name = 'Player Error';
    this.message = `Player Error (Code: ${code})${message ? `: ${message}` : ''}`;
    this.code = code;
    console.error(this);
  }
}
